module.exports = __webpack_public_path__ + "media/images/new_landing/for/price-3-5aacb5e4954d9a2dd190585a4f644426.jpg";